// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebar_Spa.js
import React, { useState, useEffect } from 'react';
import { Sidebar, InputSwitch, ProgressSpinner } from 'primereact';
import { Row, Col } from 'react-bootstrap';
import '../../css/EventDialogServiceTimeSidebar.scss';
import PaymentDetails from './EventDialogServiceTimeSidebar/PaymentDetails';
import InputSwitchWrapper from './EventDialogServiceTimeSidebar/InputSwitchWrapper';
import PaymentMethodContainer from './EventDialogServiceTimeSidebar/PaymentMethodContainer';
import PaymentLabels from './EventDialogServiceTimeSidebar/PaymentLabels';
import SubmitButton from './EventDialogServiceTimeSidebar/SubmitButton';
import usePaymentLogic from './EventDialogServiceTimeSidebar/usePaymentLogic';

const EventDialogServiceTimeSidebar_Spa = ({
  isSidebarVisible,
  onHide,
  selectedDate,
  handleSelectedBookingTime,
  maxServiceTimes,
  showToast,
  priceID,
  fetchReserveServiceTimes,
  cumulativePrice,
  setCumulativePrice,
  handleSubmit,
  hideServiceTypeSidebar,
  onHideDialog,
  refreshParentData,
  clearCumulativePrice,
}) => {
  const [reserveServiceTimes, setReserveServiceTimes] = useState([]);
  const [selectedServiceTimesCount, setSelectedServiceTimesCount] = useState(0);
  const [statusMessage, setStatusMessage] = useState("");
  const [shouldFetch, setShouldFetch] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const {
    paymentMethodGroup1,
    paymentMethodGroup2,
    paymentPercentage,
    paymentAmount,
    loading,
    paymentDetails,
    topSidebarVisible,
    sidebarContentRef,
    setPaymentMethodGroup1,
    setTopSidebarVisible,
    setPaymentAmount,
    handlePaymentPercentageChange,
    handlePaymentMethodChangeGroup1,
    handlePaymentMethodChangeGroup2,
    handlePaymentAmountChange,
    handleInputFocus,
    handleInputBlur,
    handleSubmitClick,
    simulateAvailableTimes, // Now from usePaymentLogic
  } = usePaymentLogic({
    cumulativePrice,
    handleSubmit,
    onHide,
    hideServiceTypeSidebar,
    onHideDialog,
    refreshParentData,
  });

  useEffect(() => {
    if (isSidebarVisible && shouldFetch) {
      setPaymentMethodGroup1('payCash');
      setIsRefreshing(true);
      fetchReserveServiceTimes(selectedDate, priceID, (times) => {
        setReserveServiceTimes(simulateAvailableTimes(times));
        setIsRefreshing(false);
      });
      setSelectedServiceTimesCount(0);
      setShouldFetch(false);
    }
  }, [isSidebarVisible, selectedDate, priceID, fetchReserveServiceTimes, shouldFetch, setPaymentMethodGroup1]);

  const countUserSelectedTimes = (times) => {
    return times.filter(slot => slot.statusHH === "AvailableNow").length;
  };

  const isTimeSlotChecked = (statusHH) => {
    return statusHH === "Available" || statusHH === "AvailableNow";
  };

  const toggleAvailability = (index) => {
    setReserveServiceTimes(prevTimes => {
      const newTimes = [...prevTimes];
      const wasAvailableNow = newTimes[index].statusHH === "AvailableNow";
      newTimes[index].statusHH = wasAvailableNow ? "Unavailable" : "AvailableNow";
      const updatedSelectedServiceTimesCount = countUserSelectedTimes(newTimes);

      if (checkMaxServiceTimes(updatedSelectedServiceTimesCount)) {
        newTimes[index].statusHH = wasAvailableNow ? "AvailableNow" : "Unavailable";
        return prevTimes;
      }

      setSelectedServiceTimesCount(updatedSelectedServiceTimesCount);
      setTimeout(() => handleSelectedBookingTime(newTimes[index].time), 0);
      const status = newTimes[index].statusHH;
      setStatusMessage(`Status of ${newTimes[index].time} is ${status}`);
      sessionStorage.setItem('tempReserveServiceTimes', JSON.stringify(newTimes));
      setTopSidebarVisible(true);
      return newTimes;
    });
  };

  const checkMaxServiceTimes = (count) => {
    if (count > maxServiceTimes) {
      setTimeout(() => showToast('warn', 'Limit Exceeded', `You can only select ${maxServiceTimes} service times.`), 0);
      return true;
    }
    return false;
  };

  const resetServiceTimeSelections = () => {
    const resetTimes = reserveServiceTimes.map(slot => ({
      ...slot,
      statusHH: slot.statusHH !== "Available" && !slot.disabled ? "Unavailable" : slot.statusHH
    }));
    setReserveServiceTimes(resetTimes);
    setSelectedServiceTimesCount(0);
    sessionStorage.setItem('tempReserveServiceTimes', JSON.stringify(resetTimes));
  };

  const resetMaxServiceTimes = () => setSelectedServiceTimesCount(0);

  return (
    <>
      <Sidebar
        visible={isSidebarVisible}
        position="right"
        onHide={() => {
          onHide();
          resetServiceTimeSelections();
          setTopSidebarVisible(false);
          clearCumulativePrice();
          resetMaxServiceTimes();
          setShouldFetch(true);
        }}
      >
        <h3>Service Time</h3>
        {isRefreshing ? <ProgressSpinner /> : (
          <div>
            {reserveServiceTimes.length > 0 && reserveServiceTimes.map((timeSlot, index) => (
              <div key={index} className="p-flex p-ai-center p-my-2">
                <span className="p-mr-2">{timeSlot.time}</span>
                <InputSwitch
                  checked={isTimeSlotChecked(timeSlot.statusHH)}
                  onChange={() => toggleAvailability(index)}
                  disabled={timeSlot.statusHH === "Available" && timeSlot.disabled}
                />
              </div>
            ))}
            {statusMessage && <div className="p-mt-3">{statusMessage}</div>}
          </div>
        )}
      </Sidebar>

      <Sidebar
        visible={topSidebarVisible}
        position="bottom"
        onHide={() => {
          setTopSidebarVisible(false);
          resetServiceTimeSelections();
          if (!paymentAmount) setPaymentAmount(cumulativePrice);
          resetMaxServiceTimes();
        }}
        className="custom-bottom-sidebar"
      >
        <div className="sidebar-content" ref={sidebarContentRef}>
          <Row>
            <Col xs={4} className="cumulative-total-container text-center">
              <Row>
                <Col xs={3} className="cumulative-total-container text-center">
                  <PaymentLabels />
                </Col>
                <Col xs={4} className="payment-method-container payment-InputSwitch">
                  <InputSwitchWrapper paymentMethodGroup1={paymentMethodGroup1} handlePaymentMethodChangeGroup1={handlePaymentMethodChangeGroup1} />
                </Col>
                <Col xs={4} className="credit-card-input-container">
                  <PaymentDetails paymentMethodGroup1={paymentMethodGroup1} paymentDetails={paymentDetails} />
                </Col>
              </Row>
            </Col>
            <Col xs={4} className="payment-method-container">
              <PaymentMethodContainer
                paymentMethodGroup2={paymentMethodGroup2}
                handlePaymentMethodChangeGroup2={handlePaymentMethodChangeGroup2}
                paymentAmount={paymentAmount}
                handlePaymentAmountChange={handlePaymentAmountChange}
                handleInputFocus={handleInputFocus}
                handleInputBlur={handleInputBlur}
                paymentPercentage={paymentPercentage}
                handlePaymentPercentageChange={handlePaymentPercentageChange}
              />
            </Col>
            <Col xs={4}>
              <SubmitButton
                loading={loading}
                handleSubmitClick={() => handleSubmitClick("THB", setShouldFetch)}
                cumulativePrice={cumulativePrice}
              />
            </Col>
          </Row>
        </div>
      </Sidebar>
    </>
  );
};

export default EventDialogServiceTimeSidebar_Spa;